import { Component, OnInit, Input } from '@angular/core';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.scss']
})
export class ShareButtonComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  @Input() type: 'facebook' | 'email' | 'twitter' | 'whatsapp' | 'whatsapp-web';
  @Input() shareUrl: string;
  navUrl: string;
  constructor( public dashboardService: DashboardService,
    public opdvisitService: OpdVisitService, public dialog: MatDialog,
    private router: Router,
   ) { }

  ngOnInit(): void {
    this.createNavigationUrl();
  }
  private createNavigationUrl() {
    let searchParams = new URLSearchParams();

    // TODO: zrobić map z tego manualnego dziugania
    // debugger
    switch (this.type) {
      
      case 'facebook':
        searchParams.set('u', this.shareUrl);
        this.navUrl = 'https://www.facebook.com/sharer/sharer.php?' + searchParams;
        break;
      case 'email':
        searchParams.set('u', this.shareUrl);
        this.navUrl = 'https://www.gmail.com/share?' + searchParams;
        break;
      case 'twitter':
        searchParams.set('u', this.shareUrl);
        this.navUrl = 'https://twitter.com/share?' + searchParams;
        break;
      case 'whatsapp':
          searchParams.set('text', this.shareUrl);
          this.navUrl = 'https://wa.me/919996650317?' + searchParams;
        
          break;
      case 'whatsapp-web':
            searchParams.set('url', this.shareUrl);
            this.navUrl = 'https://web.whatsapp.com/send?' + searchParams;
            break;
    }
  }

  public share() {
    return window.open(this.navUrl, "_blank");
  }

  genericSocialShare(){
    var url="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=pankajabc65@gmail.com&su=Report sharing&body="+this.link+"&ui=2&tf=1&pli=1";
    window.open(url,'sharer','toolbar=0,status=0,width=648,height=395');
    return true;
 }

 opensearchDialog(): void {
  // this.open_loader_Dialog();
 // this.dashboardService.showspinner = true;
  // this.opdvisitService.get_top_200_patients().
  //   subscribe(data => this.success_top_200_patients(data), err => this.failed_top_200_patients(err));
  const dialogRef = this.dialog.open(SearchDialogComponent, {

    panelClass: 'full-width-dialog',
    maxWidth: '100vw !important',
    height: '80%',
    width: '90%',
  });


  dialogRef.afterClosed().subscribe(result => {
// this.walkin = true;
// this.withappointment = false;
   // this.defaultautoRef.nativeElement.focus();
    //console.log('The dialog was closed');
   // this.animal = result;
  });

} 

// success_top_200_patients(data) {
//   this.dialog.closeAll();
//  // this.dashboardService.showspinner = false;
//   this.opdvisitService.patients = data;
//   console.log("patients successfully loaded");

//   // call dialogue once data get loaded inside success
//   const dialogRef = this.dialog.open(SearchDialogComponent, {

//     panelClass: 'full-width-dialog',
//     maxWidth: '100vw !important',
//     height: '80%',
//     width: '90%',
//   });


//   dialogRef.afterClosed().subscribe(result => {
// // this.walkin = true;
// // this.withappointment = false;
//    // this.defaultautoRef.nativeElement.focus();
//     //console.log('The dialog was closed');
//    // this.animal = result;
//   });

// }

failed_top_200_patients(err) {
  this.dialog.closeAll();
 // this.dashboardService.showspinner = false;

}


}
